<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>Controllers</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" @click="showAddModal()">ADD CONTROLLER</b-button>
					<b-button variant="dark" pill  @click="downloadcsv()">EXPORT</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row class="">
					<b-col>
						<b-card img-src="../assets/street-light.svg" img-alt="Card image" img-left class="info-box mb-3">
							<h6>Total Lights</h6>
							<b-card-text>
								{{records.length}}
							</b-card-text>
						</b-card>
					</b-col>
					<b-col>
						<b-card img-src="../assets/light-on.svg" img-alt="Card image" img-left class="info-box mb-3">
							<h6>Total Lights ON</h6>
							<b-card-text>
								0
							</b-card-text>
						</b-card>
					</b-col>
					<b-col>
						<b-card img-src="../assets/light-off.svg" img-alt="Card image" img-left class="info-box mb-3">
							<h6>Total Light OFF</h6>
							<b-card-text>
								0
							</b-card-text>
						</b-card>
					</b-col>
					<b-col>
						<b-card img-src="../assets/no-light.svg" img-alt="Card image" img-left class="info-box mb-3">
							<h6>Temporary Signal Loss</h6>
							<b-card-text>
								0
							</b-card-text>
						</b-card>
					</b-col>
					<b-col>
						<b-card img-src="../assets/no-light.svg" img-alt="Card image" img-left class="info-box mb-3">
							<h6>Actual Load (Kwh)</h6>
							<b-card-text>
								0
							</b-card-text>
						</b-card>
					</b-col>
			</b-row>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="mt-1 container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(unique_id)="row">
										<a :href="'/controller-data/'+row.value">{{row.value}}</a>
									</template>
									<template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">DISABLED</b-badge>
										<b-badge pill variant="success" v-else>ENABLED</b-badge>
									</template>
									<template v-slot:cell(network)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">DISCONNECTED</b-badge>
										<b-badge pill variant="success" v-else>CONNECTED</b-badge>
									</template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm">EDIT</b-button>
										<b-button pill variant="danger" class="mr-1" @click="showDeleteModal(row.item)" size="sm">DELETE</b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3 mb-2">
							<b-col lg="6">
								<span class="mr-2">Showing 1 to 5 of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			<b-modal id="edit-model" :title="(selectedItem.id > 0)?'Edit Controller':'Add Controller'" size="md" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<b-container fluid>
					<b-form-group label="Unique ID" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Unique ID is required">
						<b-form-input v-model="selectedItem.unique_id" :disabled="selectedItem.id > 0" required></b-form-input>
					</b-form-group>
					<b-form-group label="Feeder Piller No" label-cols="4" label-size="sm" label-align-sm="right">
						<b-form-input v-model="feederno" disabled required></b-form-input>
					</b-form-group>
					<b-form-group label="Location" label-cols="4" label-size="sm" label-align-sm="right">
						<b-form-input v-model="selectedItem.location" required></b-form-input>
					</b-form-group>
					<b-form-group label="Status" label-cols="4" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.status" :options="$root.status_options" required></b-form-select>
					</b-form-group>
				</b-container>
				<form ref="form" @submit.stop.prevent="handleSubmit">
					
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Controller',
	components: {
		"top-header": Header
	},
	mounted(){
		this.initload();
	},
	data() {
		var self = this;
		return{
			loading: true, 
			email: '',
			password: '',
			zoneOptions: [],
			feederno: self.$route.params.feederno,
			recordUrl: self.$session.get('apiurl')+'kanpurapi/controllers',
			insertUrl: self.$session.get('apiurl')+'kanpurapi/controller-insert',
			updateUrl: self.$session.get('apiurl')+'kanpurapi/controller-update',
			deleteUrl: self.$session.get('apiurl')+'kanpurapi/controller-delete',
			records: [],
			fields: [
				{ key: 'unique_id', label: 'Unique ID', sortable: true, sortDirection: 'desc' },
				{ key: 'on_off_status', label: 'Status',
					formatter: (value) => {
						if(value == 0 || value == '0'){
							return 'LIGHT OFF';
						}
						return 'LIGHT ON';
					},
				},
				{ key: 'pwm', label: 'Brightness', sortable: true, class: 'text-center',
					formatter: (value) => {
						if(value == ''){
							return '-n/a-';
						}
						return value+'%';
					},
				},
				{ key: 'current', label: 'Current' },
				{ key: 'voltage', label: 'Voltage' },
				{ key: 'pf', label: 'PF' },
				{ key: 'kwh', label: 'Kwh' },
				{ key: 'load_kw', label: 'Load' },
				{ key: 'location', label: 'Location' },
				{ key: 'update_time', label: 'Last Update Time', 
					formatter: (value, key, item) => {
						if(item.update_time == ""){
							return '-n/a-';
						}
						return self.$moment(item.update_time).format('DD-MM-YYYY hh:mm:ss');
					},
				},
				{ key: 'status', label: 'Status' },
				{ key: 'network', label: 'Network Status',
					formatter: (value, key, item) => {
						var self = this;
						var curdatetime = self.$moment();
						var conn_status = 1;
						if(item.update_time != ""){
							var dbdatetime = self.$moment(item.update_time);
							var duration = '';
							if(curdatetime > dbdatetime){
								duration = self.$moment.duration(curdatetime.diff(dbdatetime));
							}else{
								duration = self.$moment.duration(dbdatetime.diff(curdatetime));
							}
							var minutes = duration.asMinutes();
							
							if(minutes < 15){
								conn_status = 1;
							}else{
								conn_status = 0;
							}
						}else{
							conn_status = 0;
						}
						return conn_status;
					},
				},
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {},
			emptyItem: {
				id: 0,
				imei_no: '',
				zone_id: 0,
				state_id: 0,
				ulb_id: 0,
				feeder_pillar_no: '',
				ward_no: '',
				ccms_no: '',
				total_load: '',
				no_of_poles: 0,
				no_of_fittings: 0,
				location_lat: '',
				location_lng: ''
			}
		};
	},
	methods: {
		filterZone: function (items) {
			var self = this;
			return items.filter(function (item) {
				if(item.parent ==0){
					return item.state  == self.selectedItem.state_id;
				}
			})
		},
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.parent == self.selectedItem.zone_id && item.parent > 0;
			})
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'edit-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'edit-model', button)
		},
		showViewModal(item, button){
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'view-model', button);
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete light controller.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.unique_id,
						feederno: self.feederno
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}


			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem,
				feederno: self.feederno
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('edit-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key'),
				feederno: self.feederno
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result;
					self.loading = false;
					self.totalRows = self.records.length;
					
					setTimeout(self.initload, 1000*30);
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "controller_"+self.feederno+"_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>


</style>